import { useComputedColorScheme } from '@mantine/core';
import { APP_NAME } from '../constants';

export const Logo = ({ width = 'auto', height = 100 }) => {
  const colorScheme = useComputedColorScheme('light');
  const src =
    colorScheme === 'dark'
      ? '/living-wire-logo-white.png'
      : '/living-wire-logo.png';

  return <img src={src} width={width} height={height} alt={`${APP_NAME} Logo`} />;
};
